import React, { useEffect, useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Box, Button, Container, Typography } from "@mui/material";

const DEFAULT_SCHEME = "mynetgoals://";

function buildAppDeepLink({ appScheme, votePurchase, competitionId, sessionId }) {
  const params = new URLSearchParams();
  if (votePurchase) params.set("votePurchase", votePurchase);
  if (competitionId) params.set("competitionId", competitionId);
  if (sessionId) params.set("session_id", sessionId);
  const base =
    process.env.REACT_APP_VOTE_PURCHASE_DEEP_LINK || appScheme || DEFAULT_SCHEME;
  return `${base}?${params.toString()}`;
}

/** HTTPS bridge after checkout (PayPal or Stripe). */
export default function CompetitionBuyVotesReturn() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const votePurchase = searchParams.get("votePurchase");
  const sessionId =
    searchParams.get("session_id") ||
    searchParams.get("token") ||
    searchParams.get("orderId");

  const deepLink = useMemo(
    () =>
      buildAppDeepLink({
        votePurchase,
        competitionId: id,
        sessionId,
      }),
    [votePurchase, id, sessionId]
  );

  useEffect(() => {
    window.location.replace(deepLink);
  }, [deepLink]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#0f1118",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Container maxWidth="xs" sx={{ textAlign: "center" }}>
        <Typography sx={{ color: "#fff", fontWeight: 700, mb: 2 }}>
          Returning to My Net Goals…
        </Typography>
        <Typography sx={{ color: "rgba(255,255,255,0.6)", mb: 3, fontSize: 14 }}>
          If the app does not open automatically, tap the button below.
        </Typography>
        <Button
          variant="contained"
          href={deepLink}
          sx={{
            bgcolor: "#FFCD1F",
            color: "#111",
            fontWeight: 700,
            textTransform: "none",
            "&:hover": { bgcolor: "#e6b800" },
          }}
        >
          Open app
        </Button>
      </Container>
    </Box>
  );
}
